import React, { useState } from "react";
import Pace from "../Pace/Pace";
import PaceModify from "../Pace/Pace_modify";
import ModificarClases from "../ModificarClases/ModificarClases";
import EditarClase from "../EditarClase/EditarClase";
import SubtypeManage from "../Pace/Subtype_manage";
import TabContent from "../ComponentV2/TabContent_register";
import TabNavItem from "../ComponentV2/TabNavItem_admin";
import "./pace_render.css";

const Pace_render = () => {
  const [activeTab, setActiveTab] = useState("tab1");
  return (
    <div className="tabs-pace">
      {/* Tab nav */}
      <ul className="nav-pace">
        <TabNavItem
          title="Pace"
          id="tab1"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <TabNavItem
          title="Modificar Pace"
          id="tab2"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <TabNavItem
          title="Cambiar estudiantes"
          id="tab3"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <TabNavItem
          title="Modificar clase"
          id="tab4"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <TabNavItem
          title="Sub-tipos"
          id="tab5"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </ul>
      <div className="outlet-pace">
        <TabContent id="tab1" activeTab={activeTab}>
          <Pace />
        </TabContent>
        <TabContent id="tab2" activeTab={activeTab}>
          <PaceModify />
        </TabContent>
        <TabContent id="tab3" activeTab={activeTab}>
          <ModificarClases />
        </TabContent>
        <TabContent id="tab4" activeTab={activeTab}>
          <EditarClase />
        </TabContent>
        <TabContent id="tab5" activeTab={activeTab}>
          <SubtypeManage />
        </TabContent>
      </div>
    </div>
  );
};

export default Pace_render;
